module.exports = __webpack_public_path__ + "static/img/bg-en.80330d68.png";